import React, { useEffect } from 'react';
import { Outlet } from "react-router-dom";
import { isMobile } from 'react-device-detect';

const LiveVideoLayout = (props) => {

	useEffect(() => {
		if (isMobile) {
			document.body.classList.add('mobile');
		}
	}, [])

	return (
		<div className="container">
			<Outlet />
		</div>
	);
}

export default LiveVideoLayout;
